export default "__VITE_ASSET__DGwjR7oE__"